// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iR1A","label":"styles_label__3VWDL"};